import {
  fetchGet,
  fetchPost,
  toQueryString,
} from "../../../../../service/api_client";

export const CreateInwardAndVoucher = async (data: FormData) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase`;
    const res = fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const CreateSRNInwardAndVoucher = async (data: FormData) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/srn`;
    const res = fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const ScannedBarCodeScanForDeviceAPI = async (scanned_id: string) => {
  try {
    const url =
      `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/scan-devices` +
      toQueryString({ scanned_id: scanned_id });
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false };
  }
};

export const ScannedBarCodeScanForDeviceGRNAPI = async (
  item_code: string,
  scanned_id: string,
) => {
  try {
    const url =
      `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/scan-devices-grn-pt` +
      toQueryString({ item_code: item_code, scanned_id: scanned_id });
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false };
  }
};

export const GetInwardsFromPO = async (po_no: string) => {
  const inward_url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/get-inwards`;

  const res = fetchGet(inward_url + "/" + po_no);
  return res;
};

export const GetServiceInwardsFromPO = async (po_no: string) => {
  const inward_url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/get-service-inwards`;

  const res = fetchGet(inward_url + "/" + po_no);
  return res;
};

export const GetPurchaseOrder = async (id: string) => {
  const po_url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order`;

  const res = fetchGet(po_url + "/" + id);
  return res;
};

export const GetPurchaseVoucher = async (id: string) => {
  const purchase_voucher_url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase`;

  const res = fetchGet(purchase_voucher_url + "/" + id);
  return res;
};

export const GetPurchaseServiceVoucher = async (id: string) => {
  const purchase_voucher_url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/srn`;

  const res = fetchGet(purchase_voucher_url + "/" + id);
  return res;
};

// export const GetPurchaseVoucher = async (id: string) => {
//   const purchase_voucher_url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase`;

//   const res = fetchGet(purchase_voucher_url + "/" + id);
//   return res;
// };

export const GetVoucherAttachments = async (voucher_id: string) => {
  const po_url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/${voucher_id}/attachment`;
  const res = fetchGet(po_url);
  return res;
};

export const GetGRNSummary = async (po_no: string, type: string) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/grn-summary/${po_no}/${type}`;
  const res = fetchGet(url);
  return res;
};

export const fetchWarehouseInwards = async (filters?: {
  search?: string;
  status?: string | string[];
  type?: string | string[];
  page?: number;
  fromWarehouse?: string;
  toWarehouse?: string;
  itemSearch?: string;
  sortBy?: string;
  sortOrder?: string;
}) => {
  const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/create-grn-by-spoc/get-warehouse-inwards`;

  const query = toQueryString(filters);
  const url = `${baseUrl}${query}`;

  return fetchGet(url);
};

export const exportInwardByEmail = async (filters?: {
  search?: string;
  status?: string | string[];
  type?: string | string[];
  fromDate?: string;
  toDate?: string;
  fromWarehouse?: string;
  toWarehouse?: string;
  itemSearch?: string;
  sortBy?: string;
  sortOrder?: string;
  source?: string;
  docTypes?: string;
}) => {
  const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/create-grn-by-spoc/export-inward-by-email`;
  const query = toQueryString(filters);
  return fetchGet(`${baseUrl}${query}`);
};

export const ScanAndGetDevicesOnlyAPI = async (scanned_id: string) => {
  try {
    const url =
      `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/scaned-devices-list` +
      toQueryString({ scanned_id: scanned_id });
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false };
  }
};
